/** Dependency-free confetti burst (Web Animations API). */
export function fireConfetti(): void {
  if (typeof window === "undefined") return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const colors = ["#15a35a", "#1f7ae0", "#ef7415", "#ffd23e", "#22e58f"];
  const count = 100;

  const container = document.createElement("div");
  container.style.cssText =
    "position:fixed;inset:0;pointer-events:none;z-index:2000;overflow:hidden";
  document.body.appendChild(container);

  for (let i = 0; i < count; i++) {
    const p = document.createElement("div");
    const size = 6 + Math.random() * 9;
    const color = colors[(Math.random() * colors.length) | 0];
    const round = Math.random() > 0.5;
    p.style.cssText =
      `position:absolute;top:-14px;left:${Math.random() * 100}%;` +
      `width:${size}px;height:${round ? size : size * 0.6}px;background:${color};` +
      `border-radius:${round ? "50%" : "2px"};will-change:transform,opacity`;
    container.appendChild(p);

    const dx = (Math.random() - 0.5) * 340;
    const dy = window.innerHeight + 60;
    const rot = Math.random() * 900 - 450;
    const dur = 1900 + Math.random() * 1500;

    p.animate(
      [
        { transform: "translate(0,0) rotate(0deg)", opacity: 1 },
        { transform: `translate(${dx}px,${dy}px) rotate(${rot}deg)`, opacity: 1, offset: 0.85 },
        { transform: `translate(${dx}px,${dy + 40}px) rotate(${rot}deg)`, opacity: 0 },
      ],
      { duration: dur, easing: "cubic-bezier(.2,.6,.4,1)", fill: "forwards" }
    );
  }

  setTimeout(() => container.remove(), 3600);
}
